var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1699 24C17.0383 24.0007 16.9078 23.9755 16.786 23.9258C16.6641 23.876 16.5533 23.8027 16.4599 23.71L8.28986 15.54C7.82423 15.0755 7.4548 14.5238 7.20274 13.9163C6.95067 13.3089 6.82092 12.6577 6.82092 12C6.82092 11.3423 6.95067 10.6911 7.20274 10.0837C7.4548 9.47622 7.82423 8.92446 8.28986 8.46001L16.4599 0.290017C16.5531 0.196779 16.6638 0.122818 16.7856 0.0723577C16.9074 0.0218975 17.038 -0.0040741 17.1699 -0.0040741C17.3017 -0.0040741 17.4323 0.0218975 17.5541 0.0723577C17.6759 0.122818 17.7866 0.196779 17.8799 0.290017C17.9731 0.383256 18.0471 0.493946 18.0975 0.615768C18.148 0.737589 18.174 0.868157 18.174 1.00002C18.174 1.13188 18.148 1.26244 18.0975 1.38427C18.0471 1.50609 17.9731 1.61678 17.8799 1.71002L9.70986 9.88001C9.14806 10.4425 8.8325 11.205 8.8325 12C8.8325 12.795 9.14806 13.5575 9.70986 14.12L17.8799 22.29C17.9736 22.383 18.048 22.4936 18.0988 22.6154C18.1495 22.7373 18.1757 22.868 18.1757 23C18.1757 23.132 18.1495 23.2627 18.0988 23.3846C18.048 23.5064 17.9736 23.617 17.8799 23.71C17.7864 23.8027 17.6756 23.876 17.5538 23.9258C17.4319 23.9755 17.3015 24.0007 17.1699 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic-back.ceb51f7b943b3222ae78647df84f05c4.svg";
export { ForwardRef as ReactComponent };